import { render, staticRenderFns } from "./AddToCartOnlyIconButton.vue?vue&type=template&id=0a624bfa&"
import script from "./AddToCartOnlyIconButton.vue?vue&type=script&lang=js&"
export * from "./AddToCartOnlyIconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports